import type { UserEmail } from '@coursera/grpc-types-useremails/coursera/proto/useremails/v1/email_address';

export const getSecondaryEmail = (userEmails: UserEmail[]) => {
  return userEmails.find((email) => !email.isPrimary);
};
